/*
 * @Author: lidan
 * @Date: 2020-11-16 09:12:53
 * @LastEditTime: 2021-10-12 11:07:19
 * @LastEditors: Please set LastEditors
 * @Description: 司机津贴明细表api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\driverAllowanceDetails.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取司机津贴明细表格数据
export function queryPageDetail(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/queryPageDetail`,
    method: "post",
    data
  });
}

// 调整费用接口
export function changeFee(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/changeFee`,
    method: "post",
    data
  });
}

// 调整记录查询接口
export function getHistory(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/getHistory`,
    method: "get",
    params
  });
}

// 导出司机津贴明细表
export function detailExport(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/detailExport`,
    method: "post",
    data
  });
}

//重新计算费用
export function feeRecount(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/feeRecompute`,
    method: "post",
    data
  });
}
// 行内重新计算时，获取展示的费用
export function fetchFeeSetting(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/financialFee/showFee`,
    method: "post",
    data
  });
}
//选中人工选择计费规则后获取对应计费规则下拉
export function fetchFeeRulesList(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/financialFee/changeFee`,
    method: "post",
    data
  });
}
